module.exports = __webpack_public_path__ + "fonts/GothamSSm-Bold.df320d81.woff";